import { Suspense } from 'react'     //Suspense:包裹懒加载组件
import { Switch, BrowserRouter } from 'react-router-dom'; 
import Layout from './pages/layout/layout'

function App() {
  return (
    <BrowserRouter>
      <Suspense>
        <Switch>
          <Layout></Layout>
        </Switch>
      </Suspense>
    </BrowserRouter>
  )
}

export default App;
